import { Box, Typography } from "@mui/material";
import { ImageWithDismiss } from "shared-ui/Image/ImageWithDismiss";
import { useState } from "react";
import CropperModal from "../../universal/Image/CropModal";
import ImageFileDragAndDrop from "../../universal/Image/ImageFileDragAndDrop";

import { useUploadPhoto } from "../../universal/Image/uploadPhoto";

interface FoodImageSectionProps {
  thumbnailUrl: string | null;
  changeImage: (imageUrl: string | null) => void;
  disabled?: boolean;
}

export const FoodImageSection = ({ thumbnailUrl, changeImage, disabled }: FoodImageSectionProps) => {
  const [imageToCrop, setImageToCrop] = useState<string | null>(null);

  const [uploadPhoto, imageUploading] = useUploadPhoto({
    onComplete: (imageUrl: string): void => {
      if (imageUrl) {
        changeImage(imageUrl);
      }
    },
  });

  const handleCropComplete = async (croppedImage: string) => {
    uploadPhoto(croppedImage);
  };

  const handleRemovePhoto = () => {
    changeImage(null);
  };

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {thumbnailUrl ? (
          <ImageWithDismiss disabled={disabled} imageUrl={thumbnailUrl} onDismiss={handleRemovePhoto} />
        ) : (
          <ImageFileDragAndDrop
            disabled={disabled}
            sx={{ p: 2, textAlign: "center", flexGrow: 1 }}
            onUpload={setImageToCrop}
            loading={imageUploading}
          >
            <Typography gutterBottom>Drop Image or Click to Upload</Typography>
          </ImageFileDragAndDrop>
        )}
      </Box>
      {imageToCrop && (
        <CropperModal open={!!imageToCrop} onClose={() => setImageToCrop(null)} imageUrl={imageToCrop} onSave={handleCropComplete} />
      )}
    </>
  );
};
